import { render } from "./mentions_line.vue?vue&type=template&id=46c9ad4a"
import script from "./mentions_line.js?vue&type=script&lang=js&external"
export * from "./mentions_line.js?vue&type=script&lang=js&external"

import "./mentions_line.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__